// Medication data by category - subset from back-end/scripts/data-generator/data/veritas/medicines-by-category.json
// Filtered to only include medications with NDC codes

const medicationsByCategory = [
  {
    "_id": {
      "categoryId": "5eeb1479ad37216b03d21ea5",
      "category": "Erectile Dysfunction"
    },
    "medicine": [
      {
        "drug": "Sildenafil 20mg",
        "quantity": "30",
        "strength": "20 mg",
        "refills": 3,
        "daysSupply": 90,
        "ndc": "82009009301"
      },
      {
        "drug": "Sildenafil 50mg",
        "quantity": "30",
        "strength": "50 mg",
        "refills": 3,
        "daysSupply": 90,
        "ndc": "00069421030"
      },
      {
        "drug": "Sildenafil 100mg",
        "quantity": "30",
        "strength": "100 mg",
        "refills": 3,
        "daysSupply": 90,
        "ndc": "31722071130"
      },
      {
        "drug": "Tadalafil 5mg",
        "quantity": "30",
        "strength": "5 mg",
        "refills": 3,
        "daysSupply": 30,
        "ndc": "66993070230"
      },
      {
        "drug": "Tadalafil 10mg",
        "quantity": "30",
        "strength": "10 mg",
        "refills": 3,
        "daysSupply": 30,
        "ndc": "00093301665"
      },
      {
        "drug": "Tadalafil 20mg",
        "quantity": "30",
        "strength": "20 mg",
        "refills": 3,
        "daysSupply": 30,
        "ndc": "66993070330"
      }
    ]
  },
  {
    "_id": {
      "categoryId": "5fb5a8eea08143571bec6289",
      "category": "Premature Ejaculation"
    },
    "medicine": [
      {
        "drug": "Sertraline HCl Oral Tablet",
        "quantity": "30",
        "strength": "25 mg",
        "refills": 11,
        "daysSupply": 30,
        "ndc": "76282021290"
      },
    ]
  },
  {
    "_id": {
      "categoryId": "5f2c8b5e9d3b2c1a4c8b4568",
      "category": "Testosterone"
    },
    "medicine": [
      {
        "drug": "Testosterone Cypionate 200mg/mL",
        "quantity": "1",
        "strength": "200 mg/mL",
        "refills": 5,
        "daysSupply": 30,
        "ndc": "00574079410"
      },
      {
        "drug": "Anastrozole 1mg",
        "quantity": "30",
        "strength": "1 mg",
        "refills": 11,
        "daysSupply": 30,
        "ndc": "62756020090"
      }
    ]
  },
  {
    "_id": {
      "categoryId": "5f2c8b5e9d3b2c1a4c8b4569",
      "category": "Weight Loss"
    },
    "medicine": [
      {
        "drug": "Phentermine 37.5mg",
        "quantity": "30",
        "strength": "37.5 mg",
        "refills": 0,
        "daysSupply": 30,
        "ndc": "43547040010"
      },
      {
        "drug": "Phentermine 15mg",
        "quantity": "30",
        "strength": "15 mg",
        "refills": 0,
        "daysSupply": 30,
        "ndc": "43547039910"
      }
    ]
  },
  {
    "_id": {
      "categoryId": "5f2c8b5e9d3b2c1a4c8b456a",
      "category": "Skin Care"
    },
    "medicine": [
      {
        "drug": "Tretinoin 0.025% Cream",
        "quantity": "20",
        "strength": "0.025%",
        "refills": 11,
        "daysSupply": 30,
        "ndc": "68682018420"
      },
      {
        "drug": "Tretinoin 0.05% Cream",
        "quantity": "20",
        "strength": "0.05%",
        "refills": 11,
        "daysSupply": 30,
        "ndc": "68682018520"
      },
      {
        "drug": "Hydroquinone 4% Cream",
        "quantity": "30",
        "strength": "4%",
        "refills": 5,
        "daysSupply": 30,
        "ndc": "51672134402"
      }
    ]
  },
  {
    "_id": {
      "categoryId": "5f2c8b5e9d3b2c1a4c8b456b",
      "category": "Allergy"
    },
    "medicine": [
      {
        "drug": "Cetirizine 10mg",
        "quantity": "30",
        "strength": "10 mg",
        "refills": 11,
        "daysSupply": 30,
        "ndc": "69618001801"
      },
      {
        "drug": "Loratadine 10mg",
        "quantity": "30",
        "strength": "10 mg",
        "refills": 11,
        "daysSupply": 30,
        "ndc": "41250077510"
      }
    ]
  }
];

export default medicationsByCategory;
